export const adjective = {
	singular: "client",
	plural: "clients",
};

export const callToAction = {
	lead: "check availability",
};
